<!--Scroll to top-->
<div class="scroll-to-top" [ngClass]="{'show-scrollTop': windowScrolled}">
  <a class="bt-top btn btn-circle btn-lg btn-primary" (click)="scrollToTop()">
    <i class="ti-arrow-up"></i>
  </a>
</div>
